import React, { useState } from "react";
import { connect } from "react-redux";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import Banners from "./Banners";
import BannerGenerator from "./BannerGenerator";
import bannerGeneratorAction from "../../../../store/actions/bannerGenerator";

function SelectBannerGenerator({ setImageBanner }) {
  const [selectBannerGenerator, setSelectBannerGenerator] = useState(
    Banners[2]
  );

  return (
    <>
      <Sidebar openItem="all-advertise" activeItem="banner-generator" />

      <div className="content-wrapper">
        <TitleBar title="بنرساز هایلایت" />

        <section className="content pt-5" style={{ padding: "0px 3%" }}>
          <div className="card">
            <div className="card-body">
              <div className="container-fluid px-0">
                <div>
                  <p className="text-center">
                    اندازه بنر مورد نظر خود را انتخاب کنید (ارتفاع-عرض)
                  </p>
                  <div
                    className="row text-center"
                    id="button-size-banner-generator"
                  >
                    {Banners.map((banner) => {
                      let isActive = false;
                      if (
                        selectBannerGenerator.size.width == banner.size.width &&
                        selectBannerGenerator.size.height == banner.size.height
                      ) {
                        isActive = true;
                      }
                      return (
                        <div className="col-6 py-1">
                          <span>
                            <button
                              className={`btn  ${
                                isActive ? "btn-outline-primary" : "btn-primary"
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                setImageBanner({
                                  imageBrand: "",
                                });
                                setSelectBannerGenerator(banner);
                              }}
                            >
                              {banner.size.width}
                              <span className="px-2">-</span>
                              {banner.size.height}
                            </button>
                          </span>
                        </div>
                      );
                    })}
                  </div>
                  <div className="pt-2">
                    <BannerGenerator banner={selectBannerGenerator} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    setImageBanner: (action) => {
      dispatch({
        type: bannerGeneratorAction.SET_BANNER,
        payload: action,
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(SelectBannerGenerator);
